export class BasePermissionModel {
  public view: boolean;
  public delete: boolean;
  public insert: boolean;
  public edit: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/models/base-permission-model.ts